import React, { useState, useEffect } from 'react';
import { ReactComponent as ScrollArrowUp } from '../assert/images/Common/scrollArrowUp.svg';
import { StyledFab } from './Component.style';

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.pageYOffset > 4000);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    //   behavior: 'smooth',
    });
  };

  return (
    visible && (
      <StyledFab aria-label="Scroll to top" onClick={scrollToTop}>
        <ScrollArrowUp />
      </StyledFab>
    )
  );
};

export default ScrollToTopButton;
